import React from "react";
const kennitala = require('kennitala');
import { convertPeriodDataToFile, uploadFiles } from '../utils.js';
import connectWithStore from '../../../utils/store';
import { store } from '../../../store';
import moment from 'moment';
import { formatNumber } from '../../../utils';

const styles = {
    header: {borderBottom: "1px black solid"},
    headerLabel: {width: "60px"},
    reportRows: {borderBottom: "1px black solid"},
    totals: {borderBottom: "1px black solid"},
    row: {display: "flex"},
    rowLabel: {flex: "auto", fontWeight: "bold"},
    rowValue: {flex: "auto"},
};



class ConfirmSkilagrein extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            step: 0,
            errorMsg: ''
        }

        this.uploadSkilagrein = this.uploadSkilagrein.bind(this);
        this.printSkilagreinReport = this.printSkilagreinReport.bind(this);
    }

    printSkilagreinReport(e) {
        e.preventDefault();
        const reportElement = document.getElementById('skilagrein-report');

        if (!reportElement) {
            this.setState({ errorMsg: 'Tókst ekki að finna skilagrein til prentunar.' });
            return;
        }

        const printWindow = window.open('', '_blank', 'width=1024,height=768');
        if (!printWindow) {
            this.setState({ errorMsg: 'Vafrinn lokaði á prentunargluggann.' });
            return;
        }

        printWindow.document.write(`
            <html>
                <head>
                    <title>Skilagrein til Allianz</title>
                    <style>
                        body { font-family: Arial, sans-serif; margin: 20px; }
                    </style>
                </head>
                <body>${reportElement.innerHTML}</body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    }

    async uploadSkilagrein(e) {
        e.preventDefault();
        const company = this.props.companyDetails.data.Customer;
        const skilagreinUpload = convertPeriodDataToFile(
            company,
            this.props.skilagrein.period,
            this.props.skilagrein.periodRows,
            /* optional */ null
        );
        const that = this;
        try {
            await uploadFiles([skilagreinUpload],company.EmployerId)
                .then((response) => {
                    if (response && response.ok) {
                        that.setState({ step: 1, errorMsg: '' });
                    } else {
                        that.setState({ step: 0, errorMsg: 'Villa við upphleðslu skjals: '+response.statusText });
                    }
                })
                .catch((err) => {
                    that.setState({ step: 0, errorMsg: "Villa við upphleðslu skjals: "+err.statusText});
                });
        }
        catch (err) {
            this.setState({ step: 0, errorMsg: "Villa við upphleðslu skjals: " + err.toString()});
        }        
    }

    
    render() {
        const skilagrein = this.props.skilagrein;
        skilagrein.employer = this.props.companyDetails.data.Customer;
        let premiumSum = 0;
        let counterPremiumSum = 0;
        let skilagreinIsOk = true;
        let tmpValue = 0;
        switch (this.state.step) {
            case 0:
                return (
                    <>
                        { this.state.errorMsg &&
                            <div className="msg">
                                <h4 className="msg error-msg">
                                    {this.state.errorMsg}
                                </h4>
                            </div>
                        }
                        <div id="skilagrein-report">
                            <div className="header" style={styles.header}>
                                <h3 align="center" className="header">Skilagrein til Allianz</h3>

                                <div className="period">
                                    <label style={styles.rowLabel}>Tímabil:&nbsp;</label>
                                    <span className="fromDate">{moment(skilagrein.period.first).format('D.M.YYYY')}</span>
                                    <span> - </span>
                                    <span className="toDate">{moment(skilagrein.period.last).format('D.M.YYYY')}</span>
                                </div>

                                <div className="description">
                                    <label style={styles.rowLabel}>Lýsing:&nbsp;</label>
                                    <span>{skilagrein.description}</span>
                                </div>


                                <div className="employer">
                                    <label style={styles.rowLabel}>Launagreiðandi:&nbsp;</label>
                                    <span>{skilagrein.employer.Name} - {skilagrein.employer.EmployerId}</span>
                                </div>

                            </div>
                            <div className="report-rows" style={styles.reportRows}>
                                <div style={styles.row}>
                                    <div style={{width: "30%", ...styles.rowLabel}}>Launamaður</div>
                                    <div style={{width: "20%", ...styles.rowLabel}}>Sjóður</div>
                                    <div style={styles.rowLabel}>Iðgjald</div>
                                    <div style={styles.rowLabel}>Mótframlag</div>
                                </div>
                                <div>
                                {skilagrein.periodRows.map((row) => {
                                    skilagreinIsOk = skilagreinIsOk && ( row.error === '' );
                                    // we need to support both strings and numbers
                                    if (typeof row.premium === 'number') {
                                        premiumSum = premiumSum + row.premium;
                                        row.premium = formatNumber(row.premium);
                                    } else {
                                        tmpValue = parseInt(row.premium.replace(/[,.]/g, ''));
                                        premiumSum = premiumSum + tmpValue;
                                        row.premium = formatNumber(tmpValue);
                                    }
                                    if (typeof row.counterPremium === 'number') {
                                        counterPremiumSum = counterPremiumSum + row.counterPremium;
                                        row.counterPremium = formatNumber(row.counterPremium);
                                    } else {
                                        tmpValue = parseInt(row.counterPremium.replace(/[,.]/g, ''));
                                        counterPremiumSum = counterPremiumSum + tmpValue;
                                        row.counterPremium = formatNumber(tmpValue);
                                    }
                                    
                                    return <div style={styles.row}>
                                        <div style={{width: "30%",whiteSpace: "nowrap", overflowX:"hidden", ...styles.rowValue}}>
                                            {row.kennitala}&nbsp;&nbsp;
                                            {row.name}
                                        </div>    
                                        <div style={{width: "20%", ...styles.rowValue}}>X941 - Allianz</div>
                                        <div style={styles.rowValue}>{row.premium}</div>
                                        <div style={styles.rowValue}>{row.counterPremium}</div>
                                    </div>
                                })}
                                </div>
                                <div style={styles.row}>
                                    <div style={{width: "30%", ...styles.rowValue}}>
                                        Samtals
                                    </div>    
                                    <div style={{width: "20%", ...styles.rowValue}}>&nbsp;</div>
                                    <div style={styles.rowValue}>{formatNumber(premiumSum)}</div>
                                    <div style={styles.rowValue}>{formatNumber(counterPremiumSum)}</div>
                                </div>
                            </div>
                            <div className="totals" style={styles.totals}>
                                <div style={styles.row}>
                                    <div style={{width: "20%", ...styles.rowLabel}}>Sjóður</div>
                                    <div style={{width: "20%" ,...styles.rowLabel}}>Iðgjald</div>
                                    <div style={{width: "20%" ,...styles.rowLabel}}>Mótframlag</div>
                                    <div style={styles.rowLabel}></div>
                                </div>
                                <div style={styles.row}>
                                    <div style={{width: "20%", ...styles.rowValue}}>X941 - Allianz</div>
                                    <div style={{width: "20%", ...styles.rowValue}}>{formatNumber(premiumSum)}</div>
                                    <div style={{width: "20%", ...styles.rowValue}}>{formatNumber(counterPremiumSum)}</div>
                                    <div style={styles.rowValue}></div>
                                </div>
                                <div style={styles.row}>
                                    <div style={{width: "20%", ...styles.rowValue}}>Samtals</div>
                                    <div style={{width: "20%", ...styles.rowValue}}>{formatNumber(premiumSum)}</div>
                                    <div style={{width: "20%", ...styles.rowValue}}>{formatNumber(counterPremiumSum)}</div>
                                    <div style={styles.rowValue}></div>
                                </div>                        
                            </div>
                            <div className="report-footer" style={{marginTop: "20px"}}>
                            {skilagreinIsOk 
                             ?  <>
                                    <p>
                                        Gjalddagi og eindagi.<br/>
                                        Gjalddagi hvers mánaðar er 10. dagur næsta mánaðar á eftir iðgjaldamánuði.
                                        Eindagi er síðasti virki dagur næsta mánaðar á eftir iðgjaldamánuði. Ef greitt er
                                        eftir eindaga reiknast dráttarvextir frá gjalddaga.
                                    </p>
                                    <p>
                                        Fyrirvari vegna vanskila. Lífeyrissjóðurinn áskilur sér rétt til að ráðstafa mótteknum
                                        greiðslum upp í eldri iðgjaldaskuldir og dráttarvexti á undan iðgjöldum þessarar skilagreinar.
                                    </p>
                                    <br/>
                                    <p>
                                        { this.props.skilagrein.employer.CreateDeclarationClaim === 1
                                        ?
                                            <span style={{fontWeight: "bold"}}>Krafa verður stofnuð í netbanka</span>
                                        :
                                            <span style={{fontWeight: "bold"}}>Krafa verður EKKI stofnuð í netbanka</span>
                                        }
                                        &nbsp;(Þú getur breytt þessu á <a href="" onClick={e => {e.preventDefault();document.getElementById('uncontrolled-tab-example-tab-employerDeclarations').click();}}>fyrsta flipa</a>)
                                    </p>
                                    <br/>
                                    <p>
                                        Kennitala Allianz: 580991-1069<br/>
                                        Banki Allianz: 0518-26-850000
                                    </p> 
                                </>
                             :  <div className="msg error-msg">
                                    <p>
                                        Villa í skilagrein!
                                    </p>
                                    <p>
                                        Vinsamlegast lagið villur og reynið aftur.
                                    </p>
                                </div>
                            }
                            </div>
                        </div>
                        <div>
                            <button 
                                className="back-btn btn btn-outline-secondary xs-m-10"
                                onClick={(e) => {e.preventDefault();this.props.onBack(e);}}
                            >
                                Til baka
                            </button>
                            <button 
                                className="confirm-btn btn btn-primary xs-m-10"
                                onClick={this.uploadSkilagrein}
                                disabled={!skilagreinIsOk}
                            >
                                Staðfesta
                            </button>
                            <button
                                className="print-btn btn btn-outline-secondary xs-m-10"
                                onClick={this.printSkilagreinReport}
                                style={{float: 'right'}}
                                title="Prenta skilagrein"
                                aria-label="Prenta skilagrein"
                            >
                                🖨
                            </button>

                        </div>
                    </>
                );
            case 1:
                return (<>
                    <div id="skilagrein-uploaded">
                            <div className="header" style={styles.header}>
                                <h3 align="center" className="header">Skilagrein til Allianz</h3>
                            </div>
                            <div className="msg" style={{marginTop: "20px"}}>
                                <div className="success-msg" style={{fontSize: "20px"}}>
                                    Skilagrein hefur verið móttekin!
                                    <br/>
                                    <br/>
                                </div>
                                <button 
                                    className="back-btn btn btn-outline-secondary xs-m-10"
                                    onClick={(e) => {e.preventDefault(); this.props.onFinalBack ? this.props.onFinalBack(e) : this.props.onBack(e);}}
                                >
                                    Til baka
                                </button>

                            </div>
                    </div>                
                </>);
        }
    }

}


function mapStateToProps(state) {

    var f = {
        companyDetails: {},
    }
    f.companyDetails = (state.companyDetails === undefined) ? {} : state.companyDetails
    return f;
}


export default connectWithStore(store, ConfirmSkilagrein, mapStateToProps);